/**
 * bootprompt.js locale configuration
 * locale : English
 * author : Nick Payne
 */

import { addLocale } from "../bootprompt";

addLocale("en", {
  OK: "OK",
  CANCEL: "Cancel",
  CONFIRM: "OK",
});
